<!-- =========================================================================================
  File Name: createWithdrawal.vue
  Description: Create Withdrawal component
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 2020-09-08
========================================================================================== -->
<template>
  <div id="Aggrement" ref="Aggrement">
    <div class="vx-row" >
      <div class="vx-col w-1/1 md:w-1/1 w-full" >
        <div class="rounded-lg border border-solid d-theme-border-grey-light p-3 items-start mb-10" style="margin-left:200px; margin-right:200px;">
          <div class="mt-2" style="color:black">
            <h4 class="text-center">{{$t('WithdrawalInfoHeader')}}</h4> <br>
            <p>{{$t('WithdrawalInfoText')}}</p>
          </div>
        </div>
      </div>
      <div v-if="this.selectedItem != -1" class="vx-col w-1/1 md:w-1/2 w-full pt-6" style="font-size:11px;">
        <component :is="scrollbarTag"  class="scroll-area--nofications-dropdown pl-4 pr-4" :settings="settings" :key="$vs.rtl">

          <div class="rounded-lg border border-solid d-theme-border-grey-light p-4 items-start" :v-on="this.selectedItem != -1">
            <div class="flex">
            <img style="max-width:150px" :src="GetProviderImg(this.getSelectedData == null ? '' : this.getSelectedData.icon)" :alt="this.getSelectedData == null ? '' : this.getSelectedData.name" />
            &nbsp;&nbsp;
            <div class="mx-2 pt-2">
            <span class="font-medium block notification-title" >{{ this.getSelectedData == null ? '' : this.getSelectedData.detail }}</span>
            <small> {{$t('Commission')}}: {{ this.getSelectedData == null ? '' : this.getSelectedData.commision }}</small>
            <small> {{$t('MinAmount')}}: {{ this.getSelectedData == null ? '' : this.getSelectedData.minAmount }}</small>
            <small> {{$t('MaxAmount')}}: {{ this.getSelectedData == null ? '' : this.getSelectedData.maxAmount }}</small>
            </div>
            </div> 

            <div class="pt-2" v-if="`${getWithdrawalDescriptions}`=='CreditDebitCard'">
              <vs-collapse open-hover>
                <vs-collapse-item>
                  <div slot="header">
                    <h4>{{$t('WithdrawalCreditCard')}}</h4>
                  </div>
                  <div  v-for="item in this.$t(`withdrawalDescriptions.${getWithdrawalDescriptions}`)" :key="item.id" class="mt-4">
                      <p v-if="!item.isBold">{{item.text}}</p>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </div>

            <div class="mt-6" style="color:black">
               <vs-collapse open-hover>
                <vs-collapse-item>
                  <div slot="header">
                    <h4>{{$t('WithdrawalInfoHeader2')}}</h4>
                  </div>
                <p>{{$t('WithdrawalInfoText2')}}</p> <br>
                <p>{{$t('WithdrawalInfoText3')}}</p>
                </vs-collapse-item>
              </vs-collapse>
            </div>
          </div>
        </component>
      </div>

    <div class="vx-col w-1/1 md:w-1/2 w-full">    
    <component :is="scrollbarTag"  class="scroll-area--nofications-dropdown pl-4 pr-4" :settings="settings" :key="$vs.rtl">
    <div class="w-full">
    <vs-input :label="$t('Amount')" class="w-full mb-4" @keypress="onlyForCurrency" @click="SelectAmount()" icon-pack="feather" icon="icon-dollar-sign" icon-no-border  v-model="requestTransaction.requestAmount"  ref="AmountAmount" />
    <div class="mb-4">
    <label class="vs-input--label">{{$t('Account')}}</label>
    <v-select v-model="requestTransaction.account"  :reduce="item => item.value" :clearable="false" :options="getAccounts" v-validate="'required'" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
    <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
    </div>            
    <div class="mb-4">
      <label class="vs-input--label">{{$t('Reason')}}</label>
      <v-select :reduce="item => item.value" :clearable="false" :options="reasons" v-validate="'required'" name="reason" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      <span class="text-danger text-sm"  v-show="errors.has('reason')">{{ errors.first('reason') }}</span>
    </div>

    <vs-textarea label="Description" v-if="this.selectedItem == 0" class="w-full mb-4"  v-model="requestTransaction.comment"/>
    <div v-if="this.selectedItem === 1500"> <!-- Bank Wire -->
    <vs-input label="Bank Name" name="BankName" v-model="withdrawalDetails.BankName" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('BankName')">{{ errors.first('BankName') }}</span>
    <vs-input label="Bank Address" name="BankAddress" v-model="withdrawalDetails.BankAddress" class="w-full mb-4" icon-pack="feather" icon="icon-map" icon-no-border  />
    <vs-input label="Beneficiary Name" name="BeneficiaryName" v-model="withdrawalDetails.BeneficiaryName"  class="w-full mb-4" icon-pack="feather" icon="icon-briefcase" icon-no-border  />
    <vs-input label="Beneficiary IBAN/SWIFT" name="BeneficiaryIBAN_SWIFT" v-model="withdrawalDetails.BeneficiaryIBAN_SWIFT" class="w-full mb-4" icon-pack="feather" icon="icon-briefcase" icon-no-border  />
    <vs-input label="Beneficiary Account number" name="BeneficiaryAccountnumber" v-model="withdrawalDetails.BeneficiaryAccountnumber" class="w-full mb-4" icon-pack="feather" icon="icon-briefcase" icon-no-border  />
    <vs-checkbox  class="w-full mb-4" v-model="withdrawalDetails.trasferType">Correspondent / Intermediary Bank</vs-checkbox>
    <vs-input v-if="withdrawalDetails.trasferType" label="Bank Name, if there is any" name="BankName_IfThereIsAny" v-model="withdrawalDetails.BankName_IfThereIsAny" class="w-full mb-4" icon-pack="feather" icon="icon-briefcase" icon-no-border  />
    <vs-input v-if="withdrawalDetails.trasferType" label="Bank Address" name="BankAddress" v-model="withdrawalDetails.BankAddress" class="w-full mb-4" icon-pack="feather" icon="icon-briefcase" icon-no-border  />
    <vs-input v-if="withdrawalDetails.trasferType" label="SWIFT/IBAN" name="SWIFT_IBAN" v-model="withdrawalDetails.SWIFT_IBAN" class="w-full mb-4" icon-pack="feather" icon="icon-briefcase" icon-no-border  />
    <vs-input v-if="withdrawalDetails.trasferType" label="Account Number" name="AccountNumber" v-model="withdrawalDetails.AccountNumber" class="w-full mb-4" icon-pack="feather" icon="icon-briefcase" icon-no-border  />
    </div>
    <div v-else-if="this.selectedItem === 6000">  <!-- Perfect Money -->
    <vs-input label="Purse Number" name="PurseNumber" v-model="withdrawalDetails.PurseNumber" placeholder="Starts with U" v-validate="'required'" class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('PurseNumber')">{{ errors.first('PurseNumber') }}</span>
    </div>            
    <div v-else-if="this.selectedItem === 1400">  <!-- Webmoney -->
    <vs-input label="WMID" name="WMID" v-model="withdrawalDetails.WMID" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('WMID')">{{ errors.first('WMID') }}</span>
    <vs-input label="WMZ Purse Number" name="WMZPurseNumber" v-model="withdrawalDetails.WMZPurseNumber"  class="w-full mb-4" icon-pack="feather" icon="icon-map" icon-no-border />
    </div>
    <div v-else-if="this.selectedItem === 15000">  <!-- Credit/Debit Card PayOp -->
    <vs-input label="Name on the Card" name="NameOnTheCard" v-model="withdrawalDetails.NameOnTheCard" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('NameOnTheCard')">{{ errors.first('NameOnTheCard') }}</span>
    <vs-input label="Last 4 Digits" name="Last4Digits" v-model="withdrawalDetails.Last4Digits" class="w-full mb-4" icon-pack="feather" icon="icon-map" icon-no-border />
    </div>
    <div v-else-if="this.selectedItem === 2304">  <!-- Ethereum -->
    <vs-input label="Ethereum Address" name="EthereumAddress" v-model="withdrawalDetails.EthereumAddress" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('EthereumAddress')">{{ errors.first('EthereumAddress') }}</span>
    <vs-input label="Your Ethereum purse" name="YourEthereumPurse" v-model="withdrawalDetails.YourEthereumPurse" PlaceHolder="e.g. 0x47c8F28e6056374aBA3DF0854306c2556B104601" class="w-full mb-4" icon-pack="feather" icon="icon-map" icon-no-border />
    </div>
    <div v-else-if="this.selectedItem === 10000">  <!-- FasaPay -->
    <vs-input label="Purse Number" name="PurseNumber" v-model="withdrawalDetails.PurseNumber" placeholder="For instance FP0023" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('PurseNumber')">{{ errors.first('PurseNumber') }}</span>
    </div>
    <div v-else-if="this.selectedItem === 2300">  <!-- Bitcoin -->
    <vs-input label="Bitcoin Address" name="BitcoinAddress" v-model="withdrawalDetails.BitcoinAddress" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('BitcoinAddress')">{{ errors.first('BitcoinAddress') }}</span>
    </div>

    <div v-else-if="this.selectedItem === 1600">  <!-- Skrill -->
    <vs-input label="Skrill eMail Address" name="SkrilleMailAddress" v-model="withdrawalDetails.SkrilleMailAddress" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('SkrilleMailAddress')">{{ errors.first('SkrilleMailAddress') }}</span>
    </div>

    <div v-else-if="this.selectedItem === 1800">  <!-- Neteller -->
    <vs-input label="Neteller eMail Address" name="NetellereMailAddress" v-model="withdrawalDetails.NetellereMailAddress" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('NetellereMailAddress')">{{ errors.first('NetellereMailAddress') }}</span>
    </div>

    <div v-else-if="this.selectedItem === 13001">  <!-- StickPay -->
    <vs-input label="Associated eMail address" name="AssociatedeMailaddress" v-model="withdrawalDetails.AssociatedeMailaddress" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('AssociatedeMailaddress')">{{ errors.first('AssociatedeMailaddress') }}</span>
    </div>

    <div v-else-if="this.selectedItem === 2301 || this.selectedItem === 2305 || this.selectedItem === 2303">  <!-- Lightcoin / USDCOIN / Bitcoin Cash / Dogecoin -->
      <vs-input label="Address" name="CryptoAddress" v-model="withdrawalDetails.CryptoAddress" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
      <span class="text-danger text-sm"  v-show="errors.has('CryptoAddress')">{{ errors.first('CryptoAddress') }}</span>
    </div>

    <div v-else-if="this.selectedItem === 8000"> <!-- Local -->
      <vs-input label="Bank Name" name="BankName" v-model="withdrawalDetails.BankName" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
      <span class="text-danger text-sm"  v-show="errors.has('BankName')">{{ errors.first('BankName') }}</span>
      <vs-input label="Bank Address" name="BankAddress" v-model="withdrawalDetails.BankAddress" class="w-full mb-4" icon-pack="feather" icon="icon-map" icon-no-border  />
      <vs-input label="Account Holder Name" name="AccountHolderName" v-model="withdrawalDetails.AccountHolderName" class="w-full mb-4" icon-pack="feather" icon="icon-briefcase" icon-no-border  />
      <vs-input label="Account Number" name="AccountNumber" v-model="withdrawalDetails.AccountNumber" class="w-full mb-4" icon-pack="feather" icon="icon-briefcase" icon-no-border  />
    </div>
    <div v-else>  
    <vs-input label="WalletId" name="WalletId" v-model="withdrawalDetails.WalletId" v-validate="'required'"  class="w-full mb-4" icon-pack="feather" icon="icon-info" icon-no-border  />
    <span class="text-danger text-sm"  v-show="errors.has('WalletId')">{{ errors.first('WalletId') }}</span>
    </div>
    </div> 
    </component>
    </div> 

    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleTransactionMng from '@/store/transaction-mng/moduleTransactionMng.js'
import moduleMt4Management from '@/store/mt4-management/moduleMt4Management.js'
import vSelect from 'vue-select'
import Mgr from '@/services/SecurityService'
const user = new Mgr()

export default {
  props: {
    selectedItem : {
      type: Number,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  data () {
    return {
      bankWireModel: {
        transferType: Boolean
      },
      withdrawalDetails: {
        // Bank Wire
        BankName: '',
        BankAddress: '',
        BeneficiaryName: '',
        BeneficiaryIBAN_SWIFT: '',
        BeneficiaryAccountnumber: '',
        transferType: false,
        BankName_IfThereIsAny: '',
        CorrespondentBankAddress: '',
        SWIFT_IBAN: '',
        AccountNumber: '',
        // Perfect Money
        PurseNumber: '',
        
        // Webmoney
        WMID: '',
        WMZPurseNumber: '',

        // Credit/Debit Card PayOp
        NameOnTheCard: '',
        Last4Digits: '',

        // Ethereum
        EthereumAddress: '',
        YourEthereumPurse: '',

        // FasaPay
        // PurseNumber: '',

        // Bitcoin
        BitcoinAddress: '',

        // Skrill
        SkrilleMailAddress: '',

        // Neteller
        NetellereMailAddress: '',

        // StickPay
        AssociatedeMailaddress: '',

        // Lightcoin / USDCOIN / Bitcoin Cash
        CryptoAddress: '',

        // Local
        // BankName: '',
        // BankAddress: '',
        AccountHolderName: '',
        // AccountNumber: '',

        WalletId: ''

      },
      userInfo: null,
      user: null,
      status: null,
      user_accounts: null,
      payload: {email: null, server: 'Real'},
      user_data: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
        suppressScrollY: false
      },
      reasons: [
        {
          value: 101,
          label: 'need money'
        },
        {
          value: 102,
          label: 'bad support'
        },
        {
          value: 103,
          label: 'change broker'
        }                
      ],
      requestTransaction: {
        account: 0,
        amount: 0,
        currency: 1,
        status: 0,
        comment: '',
        note: '',
        product: 0,
        fee: 0,
        rate: 0,
        externalId: '',
        externalStatus: 0,
        ticket: 0,
        payerAmount: 0,
        requestAmount: 0,
        payerCurrency: 1,
        requestCurrency: 1,
        payerFee: 0,
        requestFee: 0,
        providerId: 0,
        providerMethodId: 0,
        walletDetail: '',
        data: {},
        wantBonus: false
      }
    }
  },
  computed: {
    getWithdrawalDescriptions () {
      if (this.getSelectedData.name === 'CreditDebitCard' || this.getSelectedData.name === 'CC_IYZ' || this.getSelectedData.name === 'CC_iPay') return 'CreditDebitCard'
      
      else return this.getSelectedData.name 
     
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    getSelectedData () {
      return this.data.find(item => {
        return item.id === this.selectedItem
      })
    },
    getAccounts () {
      if (!this.user_accounts) return []
      return this.user_accounts.map(d => ({
        label: `${d.Login  } - (L:${  d.Leverage  }) MF:(${  d.Margin_Free  })`,
        value: d.Login
      }))

    }
  },
  methods: {
    GetProviderImg (ProviderImgName) {
      if (ProviderImgName === '') return ''
      return require(`@/assets/images/providers/${ProviderImgName}`)
    },
    onlyForCurrency ($event) {  
      this.requestTransaction.requestAmount = `${this.requestTransaction.requestAmount  }`
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.requestTransaction.requestAmount.indexOf('.') !== -1)) { // 46 is dot
        $event.preventDefault()
      }
      if (this.requestTransaction.requestAmount && this.requestTransaction.requestAmount.indexOf('.') > -1 && (this.requestTransaction.requestAmount.split('.')[1].length > 1)) {
        $event.preventDefault()
      }
    },

    ResetFormData () {
      this.requestTransaction.requestAmount = 0
      this.requestTransaction.wantBonus = false
      this.requestTransaction.account = this.requestTransaction.comment = ''
    },
    SelectAmount () {
      this.$refs.AmountAmount.$refs.vsinput.select()
    },
    startProcess () {
      return new Promise((resolve, reject) => {
        this.requestTransaction.providerMethodId = this.selectedItem
        this.requestTransaction.amount = this.requestTransaction.requestAmount
        this.requestTransaction.wantBonus = this.requestTransaction.wantBonus === false ? 0 : 1
        this.requestTransaction.platform = 4 //MT5
        this.requestTransaction.providerCurrency = 6 //TRY

        console.error(this.requestTransaction)
        this.$store.dispatch('TransactionMng/addWithdrawal', this.requestTransaction)
          .then(res => { 

              console.error(res);

            if (res.data.isSuccess) {
              this.$vs.notify({
                title: 'Success',
                text: 'Has Been Successfully',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check-circle'
              })
            } else {
              this.$vs.notify({
                title: 'Failed',
                text: res.data.data,
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            }
          
            resolve(res)
          })
          .catch(err => {
            reject(`correct all values. ${  err}`)
          })
      })
    },
    getUserAccounts () {
      user.getUser()
        .then(u => {
          this.user = u
        })
      user.getProfile()
        .then(response => {
          this.userInfo = response
          if (this.userInfo) {
            this.payload.email = this.$store.state.AppActiveUser.email
            // this.payload.email = this.userInfo.email
            this.payload.server = 'Real'
            this.$store.dispatch('TransactionMng/fetchUserAccountsByEmail', this.payload)
              .then(res => { 
                this.user_accounts = res.data.data
                console.error(this.user_accounts)
              })
              .catch(err => {
                console.error(err) 
              })          
          }
        })
      

    }
  },

  created () {
    if (!moduleTransactionMng.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionMng)
      moduleTransactionMng.isRegistered = true
    }

    if (!moduleMt4Management.isRegistered) {
      this.$store.registerModule('Mt4Management', moduleMt4Management)
      moduleMt4Management.isRegistered = true
    }

    this.getUserAccounts()
  }
}

</script>
